import SavedCardList from 'shared-assets/components/CreditCardDisplay/SavedCardListThemed';

angular
    .module('kareo.ui.shared.directives.tebra-payment-cards-on-file', [
        'react'
    ])
    .directive('tebraPaymentCardsOnFile', dcTebraPaymentCardsOnFile);

dcTebraPaymentCardsOnFile.$inject = ['reactDirective'];

function dcTebraPaymentCardsOnFile(reactDirective) {
    const bindings = {
        cards: '=',
        config: '=',
    };

    return reactDirective(SavedCardList, bindings, props => {
        return props;
    });
}